/**
 * @classdesc
 * Digitalisierungs-Modul-Geoporcessing-Panel.
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCDigitize
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCDigitize} options.module Modul-Instanz
 */
gc.gis.module.GCDigitize.GeoporcessingPanel = function(options)
{
	gc.gis.assert.isSet(options);
	gc.gis.assert.isInstance(options.module, gc.gis.module.GCDigitize);

	/**
	 * @type {gc.gis.module.GCDigitize}
	 * @private
	 */
	this._module = options.module;

	var options_widget = {
		className: 'gc-digitize-panel-geoprocessing',
		actionbar: this._initActionbar()
	};

	gc.gis.widget.GCPanel.call(this, options_widget);

	this._render();
	this._initContent();
};
gc.gis.module.GCDigitize.GeoporcessingPanel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * Initialisiert den Panel-Inhalt
 *
 * @protected
 * @method
 */
gc.gis.module.GCDigitize.GeoporcessingPanel.prototype._initContent = function()
{
	var self = this,
		controls = [],
		visibility = {},
		visibilityExcludes = ['digitize_geoproc_operation'],
		name;

	visibility[gc.gis.module.GCDigitizeConstants.OP_TRANSLATION] = [];
	visibility[gc.gis.module.GCDigitizeConstants.OP_ROTATION] = [];
	visibility[gc.gis.module.GCDigitizeConstants.OP_SCALING] = [];
	visibility[gc.gis.module.GCDigitizeConstants.OP_BUFFER] = [];
	visibility[gc.gis.module.GCDigitizeConstants.OP_INTERSECTION_LAYER] = [];
	visibility[gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_LAYER] = [];

	controls[controls.length] = {
		label: 'Operation',
		name: 'digitize_geoproc_operation',
		tooltip: 'Geometrieverarbeitungswerkzeug auswählen.',
		type: 'select',
		change: function(evt, control) {
			self._updateForm(control.getValue('digitize_geoproc_operation'), visibility, visibilityExcludes);
		},
		options: [
			{
				value: gc.gis.module.GCDigitizeConstants.OP_TRANSLATION,
				label: 'Verschiebung'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_ROTATION,
				label: 'Rotation'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_SCALING,
				label: 'Skalierung'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_CENTROID,
				label: 'Schwerpunktbildung'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_UNION,
				label: 'Vereinigung'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_BUFFER,
				label: 'Puffer'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_INTERSECTION,
				label: 'Verschneidung'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_AB,
				label: 'Differenz A/B'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_BA,
				label: 'Differenz B/A'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_SYM_DIFFERENCE,
				label: 'symmetrische Differenz'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_CONVEX_HULL,
				label: 'konvexe Hülle'
			},
			{
				value: gc.gis.module.GCDigitizeConstants.OP_VALIDATION,
				label: 'Validierung'
			}
			// {
			// 	value: gc.gis.module.GCDigitizeConstants.OP_INTERSECTION_LAYER,
			// 	label: 'Verschneidung mit Fachebene'
			// },
			// {
			// 	value: gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_LAYER,
			// 	label: 'Differenzbildung mit Fachebene'
			// }
		]
	};

	// Formularelemente für Verschiebung
	name = 'digitize_geoproc_delta_x';
	controls[controls.length] = {
		label: 'Delta X',
		name: name,
		type: 'number'
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_TRANSLATION].push(name);

	name = 'digitize_geoproc_delta_y';
	controls[controls.length] = {
		label: 'Delta Y',
		name: name,
		type: 'number'
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_TRANSLATION].push(name);

	// Formularelemente für Rotation
	name = 'digitize_geoproc_angle';
	controls[controls.length] = {
		label: 'Winkel in Grad',
		name: name,
		type: 'number'
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_ROTATION].push(name);

	// Formularelemente für Skalierung
	// Formularelemente für Rotation
	name = 'digitize_geoproc_scalefactor_x';
	controls[controls.length] = {
		label: 'Skalierungsfaktor in X',
		name: name,
		type: 'number'
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_SCALING].push(name);

	name = 'digitize_geoproc_scalefactor_y';
	controls[controls.length] = {
		label: 'Skalierungsfaktor in Y',
		name: name,
		type: 'number'
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_SCALING].push(name);

	// Formularelemente für Pufferbildung
	name = 'digitize_geoproc_buf_distance';
	controls[controls.length] = {
		label: 'Distanz/Pufferbreite',
		name: name,
		type: 'number',
		value: '10.0'
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_BUFFER].push(name);

	name = 'digitize_geoproc_buf_cap';
	controls[controls.length] = {
		label: 'Pufferende',
		name: name,
		type: 'select',
		options: [
			{
				value: gc.gis.geom.GCGeometryOperationParameters.BUFFER_CAP_ROUND,
				label: 'rund'
			},
			{
				value: gc.gis.geom.GCGeometryOperationParameters.BUFFER_CAP_FLAT,
				label: 'flach'
			},
			{
				value: gc.gis.geom.GCGeometryOperationParameters.BUFFER_CAP_SQUARE,
				label: 'quadratisch'
			}
		]
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_BUFFER].push(name);

	name = 'digitize_geoproc_buf_num_seg';
	controls[controls.length] = {
		label: 'Anzahl Segmente pro Kreisviertel',
		name: name,
		type: 'number',
		value: '16'
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_BUFFER].push(name);

	// Formularelemente für Fachebenen-Operationen
	name = 'digitize_geoproc_fe';
	controls[controls.length] = {
		label: 'Fachebene',
		name: name,
		type: 'select',
		options: []
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_INTERSECTION_LAYER].push(name);
	visibility[gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_LAYER].push(name);

	name = 'digitize_geoproc_fe_filter';
	controls[controls.length] = {
		label: 'Fachebenen-Filter',
		name: name,
		type: 'select',
		options: []
	};
	visibility[gc.gis.module.GCDigitizeConstants.OP_DIFFERENCE_LAYER].push(name);

	var form_config = {
		controls: controls
		// validate: function(form, params) {},
		// submit: function(form, params) {},
		// error: function(form, err) {}
	};

	this.form = gc.gis.util.GCFormRenderer.renderForm(form_config);

	this.form.setValue('digitize_geoproc_delta_x', '0.0');
	this.form.setValue('digitize_geoproc_delta_y', '0.0');
	this.form.setValue('digitize_geoproc_angle', '0.0');
	this.form.setValue('digitize_geoproc_scalefactor_x', '1.0');
	this.form.setValue('digitize_geoproc_scalefactor_y', '1.0');
	this.form.setValue('digitize_geoproc_buf_distance', '10.0');
	this.form.setValue('digitize_geoproc_buf_num_seg',
		gc.gis.geom.GCGeometryOperationParameters.BUFFER_DEFAULT_QUADRANT_SEGMENTS);

	this.element_content.append(this.form.getElement());

	// initiale Sichtbarkeit der Steuerelemente setzen
	this._updateForm(gc.gis.module.GCDigitizeConstants.OP_TRANSLATION, visibility, visibilityExcludes);
};

/**
 * Initialisiert die Actionbar.
 *
 * @method
 * @return {Object}
 * @private
 */
gc.gis.module.GCDigitize.GeoporcessingPanel.prototype._initActionbar = function()
{
	var self = this,
		operation,
		params;

	this._btn_save = new gc.gis.widget.GCItem({
		label: 'Anwenden',
		className: 'btn btn-default',
		icon: 'action-apply',
		click: function(evt) {
			try
			{
				operation = self.form.getValue('digitize_geoproc_operation');
				switch (operation)
				{
					case gc.gis.module.GCDigitizeConstants.OP_TRANSLATION:
						params = {
							delta_x: parseFloat(self.form.getValue('digitize_geoproc_delta_x').replace(',', '.').replace(/\.+$/, '')),
							delta_y: parseFloat(self.form.getValue('digitize_geoproc_delta_y').replace(',', '.').replace(/\.+$/, ''))
						};
						params.delta_x = isNaN(params.delta_x) ? 0.0 : params.delta_x;
						params.delta_y = isNaN(params.delta_y) ? 0.0 : params.delta_y;
						break;
					case gc.gis.module.GCDigitizeConstants.OP_ROTATION:
						params = {
							angle: parseFloat(self.form.getValue('digitize_geoproc_angle').replace(',', '.').replace(/\.+$/, ''))
						};
						params.angle = isNaN(params.angle) ? 0.0 : params.angle;
						break;
					case gc.gis.module.GCDigitizeConstants.OP_SCALING:
						params = {
							factor_x: parseFloat(self.form.getValue('digitize_geoproc_scalefactor_x').replace(',', '.').replace(/\.+$/, '')),
							factor_y: parseFloat(self.form.getValue('digitize_geoproc_scalefactor_y').replace(',', '.').replace(/\.+$/, ''))
						};
						params.factor_x = isNaN(params.factor_x) || params.factor_x === 0.0 ? 1.0 : params.factor_x;
						params.factor_y = isNaN(params.factor_y) || params.factor_y === 0.0 ? 1.0 : params.factor_y;
						break;
					case gc.gis.module.GCDigitizeConstants.OP_BUFFER:
						params = {
							distance: parseFloat(self.form.getValue('digitize_geoproc_buf_distance').replace(',', '.').replace(/\.+$/, '')),
							segments: parseInt(self.form.getValue('digitize_geoproc_buf_num_seg')),
							cap: parseInt(self.form.getValue('digitize_geoproc_buf_cap'))
						};

						params.distance = isNaN(params.distance) ? 0.0 : params.distance;
						if (isNaN(params.segments) || params.segments < 1)
						{
							params.segments	= gc.gis.geom.GCGeometryOperationParameters.BUFFER_DEFAULT_QUADRANT_SEGMENTS;
						}
						params.segments	= Math.min(params.segments,
							6 * gc.gis.geom.GCGeometryOperationParameters.BUFFER_DEFAULT_QUADRANT_SEGMENTS);

						if (params.cap !== gc.gis.geom.GCGeometryOperationParameters.BUFFER_CAP_ROUND
							&& params.cap !== gc.gis.geom.GCGeometryOperationParameters.BUFFER_CAP_FLAT
							&& params.cap !== gc.gis.geom.GCGeometryOperationParameters.BUFFER_CAP_SQUARE)
						{
							params.cap = gc.gis.geom.GCGeometryOperationParameters.BUFFER_CAP_ROUND;
						}
						break;
				}

				self._module.geoprocess(operation, params);
			}
			catch(err)
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});

	return new gc.gis.widget.GCMenu({
		containerClassName: 'actionbar',
		items: [
			this._btn_save
		]
	})
};

/**
 * Aktualisiert das Eingebaformular in Abhängigkeit der ausgewählten Operation.
 *
 * @method
 * @param {string} operation
 * @param {Object<string,*>} visibilities
 * @param {Object<string>} excludes
 * @private
 */
gc.gis.module.GCDigitize.GeoporcessingPanel.prototype._updateForm = function(operation, visibilities, excludes)
{
	var ctrl,
		i, ii,
		config = this.form.getConfig(),
		visibility = visibilities[operation];

	for (i = 0, ii = config.controls.length; i < ii; i++)
	{
		ctrl = config.controls[i];
		if (excludes.indexOf(ctrl.name) > -1)
		{
			continue;
		}

		if (visibility && visibility.indexOf(ctrl.name) > -1)
		{
			this.form.show(ctrl.name);
		}
		else
		{
			this.form.hide(ctrl.name);
		}
	}
};